export default __webpack_public_path__ + "static/media/cvrlikot.07b3a0e7.mp3";